/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from '@compiled/react';

import DiagramSymbolMindMapIcon from '@atlaskit/icon-lab/core/diagram-symbol-mind-map';
import StickerIcon from '@atlaskit/icon-lab/core/sticker';
import ShapesIcon from '@atlaskit/icon/core/shapes';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import { token } from '@atlaskit/tokens';

import { PROGRESS_BAR_TEST_ID_SUFFIX, SLIDE_MORPH_TEST_ID_SUFFIX } from './constants';
import ProgressBar from './progress-bar';
import SlideMorph from './slide-morph';
import type { IconCarouselVariantProps } from './types';
import { useFakeProgress } from './use-fake-progress';

const containerStyles = css({
	position: 'absolute',
	inset: 0,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	backgroundColor: token('elevation.surface.sunken'),
});

const innerStyles = css({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: token('space.250'),
});

const progressBarWrapperStyles = css({
	width: '172px',
});

const defaultIcons = [WhiteboardIcon, DiagramSymbolMindMapIcon, ShapesIcon, StickerIcon];

export default function IconCarouselVariant({
	animationDisabled = false,
	icons,
	testId,
}: IconCarouselVariantProps): JSX.Element {
	const progress = useFakeProgress(animationDisabled);

	return (
		<div css={containerStyles} data-testid={testId}>
			<div css={innerStyles}>
				<SlideMorph
					animationDisabled={animationDisabled}
					icons={icons ?? defaultIcons}
					testId={testId ? `${testId}--${SLIDE_MORPH_TEST_ID_SUFFIX}` : undefined}
					cycleDirection="right"
				/>
				<div css={progressBarWrapperStyles}>
					<ProgressBar
						ariaLabel="Loading"
						testId={testId ? `${testId}--${PROGRESS_BAR_TEST_ID_SUFFIX}` : undefined}
						value={progress}
					/>
				</div>
			</div>
		</div>
	);
}
